module.exports = "<p>details-claim works!</p>\n"